import { proxy } from 'valtio'
import { derive, devtools } from 'valtio/utils'
import { type ApiCallType } from '../types/ApiCallType'
import { type GlobalTransactionHisType } from '../types/GlobalTransactionHisType'
import { type Transaction } from './transactionsProxy'

export enum TransactionTab {
  PaymentDetails = 'payment_details',
  TechnicalDetails = 'technical_details'
}
export interface TransactionProxyType {
  apiCall: ApiCallType
  selectedTab: string
  transaction: GlobalTransactionHisType | null
  relatedTransactions: Transaction[] | null
}

const baseProxy = proxy({
  apiCall: {
    error: null,
    loading: false
  },
  relatedTransactions: null,
  selectedTab: TransactionTab.PaymentDetails,
  transaction: null
})

export const transactionProxy = derive({}, { proxy: baseProxy }) as TransactionProxyType

devtools(transactionProxy, { name: 'transactionProxy' })
